//react-components
import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";

//Assets
import Loginlogo from "../Assets/images/src_resources_images_ic_logo_sanerret.svg";

//Styles
import "./Login.scss";

//Strings
import { Strings } from "../Translations/i18n";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      username: "",
      password: "",
    };
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      errorMessage: "",
    });
  };

  /**
   *
   */
  handleSignIn = () => {
    if (
      this.state.username.trim() !== "" &&
      this.state.password.trim() !== ""
    ) {
      this.setState({
        errorMessage: "",
      });
      this.props.handleLogin(this.state.username, this.state.password);
    } else {
      this.setState({
        errorMessage: Strings("errorEmptyFields"),
      });
    }
  };
  /**
   * Redirects to Forgot Password
   */
  clickForgotPassword = () => {
    if (this.state.username && this.state.username.trim() !== "") {
      this.props.handleForgotPassword(this.state.username);
    } else {
      this.setState({
        errorMessage: Strings("errorEmptyUserName"),
      });
    }
  };
  /**
   * On press of 'Enter' button redirect to dashboard
   */
  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.handleSignIn();
    }
  };

  render() {
    return (
      <Row className="login">
        <Row className="loginPanel">
          <Col md={5} className="logoContainer noPadding">
            <Col md={12} className="logoName">
              <img src={Loginlogo} alt="" className="logoAlign" />
            </Col>
            <Col md={12} className="loginCopyright">
              {Strings("loginCopyright")}
            </Col>
          </Col>
          <Col md={7} className="loginValidation">
            <div className="loginText">{Strings("loginText")}</div>
            <div className="errors">
              {this.state.errorMessage !== ""
                ? this.state.errorMessage
                : this.props.errorMessage}
            </div>
            <Form.Control
              id="username"
              type="text"
              placeholder="Usuario"
              value={this.state.username}
              name={"username"}
              onChange={this.handleChange}
              onKeyPress={this.handleKeyPress}
            />
            <Form.Control
              id="password"
              type="password"
              placeholder="contraseña"
              onChange={this.handleChange}
              onKeyPress={this.handleKeyPress}
              value={this.state.password}
              name={"password"}
            />
            <Row>
              <Col md={7} className="noPadding forgotPassword">
                <span
                  onClick={this.clickForgotPassword}
                  className="cursorPointer"
                >
                  {Strings("forgotPassword")}
                </span>
              </Col>
              <Col md={5}>
                <Button variant=""
                  className="loginButton buttonBackground pull-right mx-1"
                  onClick={this.handleSignIn}
                >
                  {Strings("loginText")}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Row>
    );
  }
}

export default Login;
